// extracted by mini-css-extract-plugin
export default {"card":"DashboardTimeLineSkeleton_card__MZqvN","card-row":"DashboardTimeLineSkeleton_card-row__XBXZw"};